import { Chip, Grid, MenuItem, Stack, Typography } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import React, { useRef, useState } from "react";
import PhoneInput from "react-phone-input-2";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import PaperContainer from "../../../components/Containers/PaperContainer";
import GlobalButton from "../../../components/CustomButton";
import CustomDropDown from "../../../components/CutomDropDown";
import Label from "../../../components/Label";
import NavigationDrawer from "../../../components/NavigationDrawer";
import TextInput from "../../../components/TextInputs";
import appcolors from "../../../constants/Colors";
import globalStyle from "../../../globalStyle";
import { setActiveTab } from "../../../lib/slices/activeTabSlice";
import { t } from "i18next";

function Details() {
  const openDialog = useRef(null);
  const navigate = useNavigate();
  const { state } = useLocation();
  const dispatch = useDispatch();
  const openConfirmDialog = useRef(null);
  const [selectedItems, setSelectedItems] = useState([]);

  const handleSelect = (event) => {
    const value = event.target.value;
    if (!selectedItems.includes(value)) {
      setSelectedItems([...selectedItems, value]);
    }
  };

  const handleRemove = (item) => {
    setSelectedItems(selectedItems.filter((i) => i !== item));
  };
  // Redux states
  const activeTab = useSelector((state) => state.activeTab.tabs);

  // Functions

  const handleChangeTab = (tab) => {
    dispatch(setActiveTab({ ...activeTab, clientUsers: "clientList" }));
  };

  const renderRightPart = () => {
    return (
      <Stack
        gap={1}
        direction={"row"}
        alignItems={"center"}
        flex={1}
        justifyContent={"flex-end"}
      >
        <GlobalButton
          variant={"contained"}
          btnText={"save"}
          handleClickBtn={() => navigate(-1)}
          styleProps={{
            fontWeight: 400,
            fontSize: "0.875rem",
            height: 40,
            width: 120,
          }}
        />
      </Stack>
    );
  };

  return (
    <NavigationDrawer>
      <PaperContainer
        title={`${t("view")} ${
          state?.type == "owner"
            ? t("education")
            : state?.type == "company"
            ? t("company")
            : t("supplier")
        } ${t("details")}`}
        subtitle={t("enterAllDetails")}
        headerActions={renderRightPart()}
        showBackButton={true}
        handleBack={() => navigate(-1)}
      >
        <Typography my={1} variant="h1" fontSize={"1.125rem"} fontWeight={600}>
          {state?.type == "owner" || state?.type == "company"
            ? t("companyOwner")
            : t("supplierDetails")}
        </Typography>

        <Grid container my={2} spacing={2}>
          <Grid item xs={12} md={5}>
            <Label labelText={t("firstName")} required />
            <TextInput
              placeholder={t("firstName")}
              styleProps={globalStyle.textField}
            />
          </Grid>
          <Grid item xs={12} md={5}>
            <Label labelText={t("lastName")} required />
            <TextInput
              placeholder={t("lastName")}
              styleProps={globalStyle.textField}
            />
          </Grid>
          <Grid item xs={12} md={5}>
            <Label labelText={t("email")} required />
            <TextInput
              placeholder={t("email")}
              styleProps={globalStyle.textField}
            />
          </Grid>
          <Grid item xs={12} md={5}>
            <Label labelText={t("contactNumber")} required />
            <Stack direction={"row"} mt={2}>
              <PhoneInput
                country={"us"}
                specialLabel=""
                inputClass="cutom-phone-input-grey"
                buttonClass="custom-phone-input-button"
                onChange={(phone) => {}}
              />
            </Stack>
          </Grid>
          <Grid item xs={12} md={5}>
            <Label labelText={t("birthday")} required />
            <DatePicker sx={{ width: "100%", ...globalStyle.textField }} />
          </Grid>
          <Grid item xs={12} md={2}>
            <Label labelText={t("gender")} required />
            <CustomDropDown sx={{ maxHeight: 47 }} variant={"outlined"}>
              <MenuItem value={"Male"}>{t("male")}</MenuItem>
              <MenuItem value={"Female"}>{t("female")}</MenuItem>
            </CustomDropDown>
          </Grid>
          <Grid item xs={12}>
            <Stack
              direction={"row"}
              alignItems={"center"}
              justifyContent={"space-between"}
            >
              <Label labelText={t("address")} required />
              <Typography
                variant="body2"
                color={appcolors.slateGrey}
                sx={{ cursor: "pointer" }}
                onClick={() => openDialog.current.isVisible()}
              >
                {t("setAddress")}
              </Typography>
            </Stack>
            <TextInput placeholder={""} styleProps={globalStyle.textField} />
          </Grid>
        </Grid>
        <Typography variant="h1" fontSize={"1.125rem"} fontWeight={600}>
          {t("addServices")}
        </Typography>

        <Grid
          container
          my={1}
          spacing={2}
          display={"flex"}
          justifyContent={"center"}
        >
          <Grid item xs={12} md={5}>
            <Label labelText="Filter by service*" required />
            <CustomDropDown
              sx={{ maxHeight: 47 }}
              value=""
              onChange={handleSelect}
            >
              <MenuItem value={"Cleaning"}>{t("cleaning")}</MenuItem>
              <MenuItem value={"Laundry"}>{t("laundry")}</MenuItem>
              <MenuItem value={"House Cleaning"}>{t("houseCleaning")}</MenuItem>
            </CustomDropDown>
          </Grid>

          <Grid item xs={12} md={7}>
            <Stack
              display={"flex"}
              alignItems={"center"}
              flexDirection={"row"}
              minHeight={100}
            >
              {selectedItems.map((item, index) => (
                <Chip
                  key={index}
                  label={item}
                  onDelete={() => handleRemove(item)}
                  sx={{
                    marginRight: 1,
                    marginBottom: 1,
                    bgcolor: "primary.main",
                    color: "#FFF",
                  }}
                />
              ))}
            </Stack>
          </Grid>
        </Grid>
        <Typography variant="h1" fontSize={"1.125rem"} fontWeight={600}>
          {t("additionalInfo")}
        </Typography>

        <Grid container my={1} spacing={2}>
          <Grid item xs={12} md={5}>
            <Label labelText={t("language")} required />
            <CustomDropDown sx={{ maxHeight: 47 }}>
              <MenuItem value={"English"}>{t("english")}</MenuItem>
              <MenuItem value={"Arabic"}>{t("romanian")}</MenuItem>
            </CustomDropDown>
          </Grid>
        </Grid>
      </PaperContainer>
    </NavigationDrawer>
  );
}

export default Details;
